<template>
  <div></div>
</template>

<script>
import { mapActions } from "vuex";
import functionUtils from "Utils/functionUtils";
export default {
  data: () => ({}),
  created() {
    this.$swal.fire({
      title: "Đang xử lý !",
      timerProgressBar: true,
      onBeforeOpen: () => {
        this.$swal.showLoading();
        let confirmCode = this.$route.query.confirm_code;
        let filter = {
          confirmCode: confirmCode,
        };
        this.CONFIRM_VOUCHER_USED_FROM_CUSTOMER(filter)
          .then(
            function() {
              this.$swal
                .fire(
                  "Thông báo !",
                  "Xác nhận sử dụng Voucher thành công !",
                  "success"
                )
                .then((result) => {
                  if (result.value) {
                    this.$router.push({
                      path: "/dashboard",
                    });
                  }
                });
            }.bind(this)
          )
          .catch(
            function(error) {
              this.$swal
                .fire("Thông báo !", this.$t(functionUtils.errorResponse(error.response)), "error")
                .then((result) => {
                  if (result.value) {
                    this.$router.push({
                      path: "/dashboard",
                    });
                  }
                });
            }.bind(this)
          );
      },
    });
  },
  methods: {
    ...mapActions(["CONFIRM_VOUCHER_USED_FROM_CUSTOMER"]),
  },
};
</script>

<style></style>
